// Handle ResizeObserver errors that are common in complex UIs
export const setupResizeObserverErrorHandling = () => {
  if (typeof window === 'undefined') return;

  const resizeObserverErr = /ResizeObserver loop completed/;

  const handleError = (e) => {
    const errorMessage = e.message || e.error?.message || '';
    if (resizeObserverErr.test(errorMessage)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return false;
    }
  };

  const handleUnhandledRejection = (e) => {
    const errorMessage = e.reason?.message || e.message || '';
    if (resizeObserverErr.test(errorMessage)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  };

  window.addEventListener('error', handleError, true);
  window.addEventListener('unhandledrejection', handleUnhandledRejection);

  // Return cleanup function
  return () => {
    window.removeEventListener('error', handleError, true);
    window.removeEventListener('unhandledrejection', handleUnhandledRejection);
  };
};
